import { useAppSelector } from '../../../core/utils';
import { selectCurrentModelVehiclesByTransmissionAndColor } from '../../../core/reducers/vehicleListFilters';
import { InventoryAvailabilityStatus } from '../../../core/apis/inventoryApi';
import { getInventoryTrimFilterOptions } from '../service/utils';
const useNoInventoryData = () => {
    const vehicles = useAppSelector(selectCurrentModelVehiclesByTransmissionAndColor);
    const allTrims = getInventoryTrimFilterOptions(vehicles);
    const allModelYears = [...new Set([...vehicles.map(v => v.modelYear)])];
    const allInventoryStatuses = [InventoryAvailabilityStatus.inStock, InventoryAvailabilityStatus.onItsWay];
    return { allTrims, allModelYears, allInventoryStatuses };
};
export default useNoInventoryData;
